import React, { useEffect, useState } from "react";
import * as PR from "../../../../prime-react/index";
import { useSelector } from "react-redux";

const SummaryAppliedFilter = ({ selectedFilters, setFilters, filterVisible, filterHideShow }) => {
    const [editedFilters, setEditedFilters] = useState(selectedFilters);

    const role = useSelector(state => state.auth.role);
    const storedFilterOptions = useSelector((state) => state.filterOptions);  

    useEffect(() => {
        setEditedFilters(selectedFilters);
    }, [selectedFilters]);

    const filterTabsSelected = () => {
        const filters = [
            selectedFilters?.events,
            selectedFilters?.sports,
            selectedFilters?.tournaments,
            // selectedFilters?.date?.date,
            selectedFilters?.locations,
            selectedFilters?.betNames,
        ];
        return filters.some(filter => filter?.length > 0);
    }
    const applyFilters = () => {
        setFilters(editedFilters)
    }
    const resetFilters = () => {
        setFilters({})
    }
    const handleRemove = (propertyKey, propertyId) => {
        let newObj = {}
        if (propertyKey === "date") {
            newObj = { [propertyKey]: { date: [], dateRange: undefined } }
        } else 
        if(propertyKey === 'sports'){
            const propertyList = editedFilters[propertyKey]?.filter(property => property.id !== propertyId)
           const eventAndTournment =  removeEventsAndTournaments({id: propertyId})
            newObj = { [propertyKey]: propertyList, ...eventAndTournment };
        } else {
            const propertyList = editedFilters[propertyKey]?.filter(property => property.id !== propertyId)
            newObj = { [propertyKey]: propertyList }
        }
        
        const updated = { ...editedFilters, ...newObj }
        setEditedFilters(updated);
    }
    const removeEventsAndTournaments = ({ id }) => {
        const updateCheckedItems = (items = [], checkedItems = [], shouldConvertIdsToNumbers = false) => {
            let selectedIds = checkedItems.map(c => shouldConvertIdsToNumbers ? +c.id : c.id);

            if (!selectedIds.length) return [];

            return items.filter(
                item => selectedIds.includes(shouldConvertIdsToNumbers ? +item.id : item.id) && item.sportID !== id
            );
        };
        const events = updateCheckedItems(storedFilterOptions.event, editedFilters.events);
        const tournaments = updateCheckedItems(storedFilterOptions.tournament, editedFilters.tournaments, true);

        return { events, tournaments };
    };
    return (
        <>
            {filterTabsSelected() && (<div className='filter-applied-section'>
                <>
                    <div className="flex align-items-center justify-content-between">
                        <p>Filters Applied</p>
                        <div className="flex gap-3 search-filters-button">
                            {filterVisible &&
                                <>
                                    <PR.Button label="Reset Filters" onClick={resetFilters} className="reset-button" />
                                    <PR.Button label="Apply Filters" onClick={applyFilters} className={role === 'analyst' ? 'apply-button color-update' : 'apply-button'} />
                                </>}
                            <PR.Button className="filter_toggle_icon" outlined icon={(filterVisible) ? 'pi pi-chevron-down' : 'pi pi-chevron-up'} onClick={filterHideShow}>
                            </PR.Button>
                        </div>
                    </div>
                    {filterVisible && <hr />}
                </>
                {filterVisible && <>
                    {editedFilters.length > 0 && <hr />}
                    {/* Status */}

                    {editedFilters?.sports?.length > 0 && <div className='filters-list mb-3'>
                        <ul>
                            <li>Sports: </li>
                            {editedFilters.sports.map((e, index) => (<li key={index}><span>{e.name} <i className="pi pi-times" onClick={() => handleRemove("sports", e.id)}></i></span></li>))}
                        </ul>
                    </div>}
                    {editedFilters?.events?.length > 0 && <div className='filters-list mb-3'>
                        <ul>
                            <li>Events: </li>
                            {editedFilters.events.map((e, index) => (<li key={index}><span>{e.name} <i className="pi pi-times" onClick={() => handleRemove("events", e.id)}></i></span></li>))}
                        </ul>
                    </div>}
                    
                    {editedFilters?.tournaments?.length > 0 && <div className='filters-list mb-3'>
                        <ul>
                            <li>Tournament / League: </li>
                            {editedFilters.tournaments.map((e, index) => (<li key={index}><span>{e.name} <i className="pi pi-times" onClick={() => handleRemove("tournaments", e.id)}></i></span></li>))}
                        </ul>
                    </div>}
                    {/* {editedFilters?.date && editedFilters?.date?.dateRange !== '' && editedFilters?.date?.dateRange !== undefined && <div className='filters-list mb-3'>
                        <ul>
                            <li>Date:</li>
                            <li><span>{editedFilters.date.dateRange} <i className="pi pi-times" onClick={() => handleRemove("date", editedFilters.date.dateRange)}></i></span></li>
                        </ul>
                    </div>} */}
                    {editedFilters?.locations?.length > 0 && <div className='filters-list mb-3 textTransform'>
                        <ul>
                            <li>Property: </li>
                            {editedFilters.locations.map((e, index) => (<li key={index}><span>{e.name} <i className="pi pi-times" onClick={() => handleRemove("locations", e.id)}></i></span></li>))}
                        </ul>
                    </div>}
                    {editedFilters?.betNames?.length > 0 && <div className='filters-list mb-3 textTransform'>
                        <ul>
                            <li>Bet Type: </li>
                            {editedFilters.betNames.map((e, index) => (<li key={index}><span>{e.name} <i className="pi pi-times" onClick={() => handleRemove("betNames", e.id)}></i></span></li>))}
                        </ul>
                    </div>}
                </>}
            </div>)}
        </>
    );
};

export default SummaryAppliedFilter;